import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { Link } from '@reach/router'

import ImageCard from '../../image-card'

import './index.styl'

const GalleryCard = ({ imgUrl, onClick, isSelected }) => {
  const [isHovered, setIsHovered] = useState(false)
  return (
    <ImageCard
      className={classNames('gallery__img-item', {
        'gallery__img-item--active': isSelected,
        'gallery__img-item--hover': isHovered,
      })}
      onMouseOver={() => setIsHovered(true)}
      onMouseOut={() => setIsHovered(false)}
      imgUrl={imgUrl}
      onClick={onClick}
    />
  )
}

const Gallery = ({ pictures }) => {
  const [selectedImg, setSelectedImg] = useState(pictures[0])

  return (
    <div className="gallery">
      <ImageCard className="gallery__active-img" imgUrl={selectedImg} />
      {pictures.length > 1 && (
        <div className="gallery__img-list">
          {pictures.map(d => (
            <GalleryCard
              key={d}
              imgUrl={d}
              isSelected={ selectedImg === d }
              onClick={() => setSelectedImg(d)}
            />
          ))}
        </div>
      )}
    </div>
  )
}

Gallery.propTypes = {}

export default Gallery
